// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=dev` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  hostName: 'localhost:4200',
  apiHost: 'assets/mock-jsons/',
  segmentToken: '',
  sentry: '',
  iframeHost: 'http://staging.getachoo.com',
  intercomId: 'fkhiga69',
  pdfApiHost: 'http://staging-pdf.getachoo.com',
  facebookAppId: '',
  facebookScopes: '',
  fbRedirectUri: 'http://localhost:4200/auth-fb',
  fbAppState: 'test',
  defaultLogin: 'login',
  signUpLink: 'https://www.getachoo.com/signup-v2/signup-new',
  newInfluencerPlatform: {
    isDisableSignUp: true,
    isDisableHomePage: true,
    isDisableChat: false,
    isDisableCampaign: false,
    marketingLink: 'https://www.getachoo.com'
  },
  featureFlags: {
    newCampaignFlow: false,
    isEnableCampaignHistory: false,
    isCampaignInfluencerDetails: false,
    isEnableBestPerformingInfluencerSorting: false,
    isRequestReview: false,
    isRedesignDemographic: false,
    isEnableChannelFollowers: false,
    discoverFollower: false,
    enableInfluencerReview: false
  },
  activePlatforms: [
    'blogs',
    'instagram',
    'youtube'
  ],
  defaultTimer: 15000,
  mmiLoginUrl: 'https://media.mmi-analytics.com/en/security/login',
  mmiLogoutUrl: 'https://media.mmi-analytics.com/en/security/logout',
  faqLink: 'https://getachoo.helpsite.com/',
  mmiHubSpotFormId: null,
  cbSite: 'achoo-test'
};

export const appVersion = '0.0.2-dev';



// WEBPACK FOOTER //
// ./src/environments/environment.testing.ts